type IAuthState = {
    pageTitle: string
  }

const initialState: IAuthState = {
    pageTitle: ''
  }
  
  export default initialState
  